module.exports = __webpack_public_path__ + "static/media/no_data.8b83d7f0.png";